import Grid from '@mui/material/Grid';
import { AppBar, CompanyLogo, HistoryButtons, MegaMenuView } from '@qpr/app-bar';
import { useCurrentTenant } from '@qpr/client-library';
import { UserMenu } from '@qpr/user';
import React, { useContext } from 'react';
import HorizontalMenuView from '../modules/AppBar/components/HorizontalMenuView';
import PeriodSelector from '../modules/Components/PeriodSelector/PeriodSelector';
import AppBarContext from './BusinessPortalAppBarContext';

const BusinessPortalAppBar = () => {
  const { showAppBar, showPeriodSelector, showHistoryButtons } = useContext(AppBarContext);

  const tenant = useCurrentTenant();

  return (
    <AppBar show={showAppBar}>
      <Grid container spacing={0.5} wrap="nowrap" style={{ overflow: 'hidden' }}>
        {tenant?.menuType === 'horizontal' && (
          <Grid item zeroMinWidth>
            <HorizontalMenuView tenant={tenant.symbol} />
          </Grid>
        )}
        <Grid item zeroMinWidth>
          <CompanyLogo tenant={tenant.symbol} companyName="" />
        </Grid>
        {showHistoryButtons ? (
          <Grid item>
            <HistoryButtons />
          </Grid>
        ) : null}
        {tenant?.menuType !== 'horizontal' && (
          <Grid item xs zeroMinWidth>
            <MegaMenuView />
          </Grid>
        )}
        {showPeriodSelector ? (
          <Grid item>
            <PeriodSelector ignoredLevels={['900']} latestYears={5} />
          </Grid>
        ) : null}
      </Grid>
      <UserMenu />
    </AppBar>
  );
};

export default BusinessPortalAppBar;
